import * as React from 'react';
import { Text } from 'library';

export default function SignUpLoginHeader({ children }: { children: React.ReactNode }) {
    return (
        <Text variant="h1" bold textStyle={{ marginBottom: 10, marginTop: 5 }}>
            {children}
        </Text>
    );
}
